export default __webpack_public_path__ + "static/media/pointerIcon.4635e802.svg";